import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbxxljobApi extends DbCenterBaseApi {

  public get ControllerName(): any {
    return 'dbxxljob';
  }

  /**
   * 查询分页列表
   */
  public insertXXJob(param) {
    return this.send(param, "insertList", Methods.POST);
  }
  public getInfoByJobId(jobId){
    return this.send({jobId:jobId}, "getInfoByJobId", Methods.GET);
  }

}